export const MultipleCarsIcon = ({ className, color = 'white' }) => {
  return (
    <svg
      className={className}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
       <rect
      x={4.4375}
      y={4.80469}
      width={15.4648}
      height={15.4648}
      rx={1.5}
      fill="white"
      stroke="#070707"
    />
    <rect
      x={2.46875}
      y={2.65234}
      width={15.4648}
      height={15.4648}
      rx={1.5}
      fill="white"
      stroke="#070707"
    />
    <rect
      x={0.5}
      y={0.5}
      width={15.4648}
      height={15.4648}
      rx={1.5}
      fill="white"
      stroke="#070707"
    />
    <g clipPath="url(#clip0_6772_142743)">
      <path
        d="M2.98438 7.85547H13.4844"
        stroke="#070707"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7344 10.8555V11.9805C12.7344 12.0799 12.6949 12.1753 12.6245 12.2456C12.5542 12.316 12.4588 12.3555 12.3594 12.3555H11.2344C11.1349 12.3555 11.0395 12.316 10.9692 12.2456C10.8989 12.1753 10.8594 12.0799 10.8594 11.9805V10.8555"
        stroke="#070707"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.60938 10.8555V11.9805C5.60938 12.0799 5.56987 12.1753 5.49954 12.2456C5.42921 12.316 5.33383 12.3555 5.23438 12.3555H4.10938C4.00992 12.3555 3.91454 12.316 3.84421 12.2456C3.77388 12.1753 3.73438 12.0799 3.73438 11.9805V10.8555"
        stroke="#070707"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.23438 9.35547H5.98438"
        stroke="#070707"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4844 9.35547H11.2344"
        stroke="#070707"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7344 7.85547L11.3333 4.70312C11.3038 4.63685 11.2558 4.58054 11.1949 4.54102C11.1341 4.5015 11.0632 4.48047 10.9906 4.48047H5.47812C5.4056 4.48047 5.33462 4.5015 5.2738 4.54102C5.21299 4.58054 5.16493 4.63685 5.13547 4.70312L3.73438 7.85547V10.8555H12.7344V7.85547Z"
        stroke="#070707"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6772_142743">
        <rect
          width={12}
          height={12}
          fill="white"
          transform="translate(2.23438 2.23047)"
        />
      </clipPath>
    </defs>
    </svg>
  );
};
